import { ErrorStateIcon } from "./icons/ErrorStateIcon";

export const ErrorState = ({
  title = "Đã có lỗi xảy ra",
  description = "Chúng tôi gặp sự cố khi hiển thị nội dung này. Vui lòng thử lại sau.",
  actionText = "Tải lại trang",
  onAction = () => window.location.reload(),
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center p-[40px] text-center bg-white rounded-[16px] min-h-[300px] ${className}`}
    >
      <ErrorStateIcon />
      <h3 className="mt-[16px] text-[16px] font-semibold text-[#1F1F21]">
        {title}
      </h3>
      <p className="mt-[8px] text-[14px] text-[#636369] max-w-[280px]">
        {description}
      </p>
      {actionText && (
        <button
          onClick={onAction}
          className="mt-[20px] px-[16px] py-[8px] bg-[#1F1F21] text-white rounded-[8px] text-[14px] font-medium"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};
